// extracted by mini-css-extract-plugin
export default {"container":"MyAccountPage_container__SLqTc","contentRow":"MyAccountPage_contentRow__0E1bE","info":"MyAccountPage_info__Kg50N","content":"MyAccountPage_content__ySHnv"};